"use client"
import React, { useState, useEffect } from "react";
import { Form, FormControl } from "react-bootstrap";

const MaxCharacterField = ({
  id,
  title,
  text,
  required,
  schema,
  fieldName,
  value,
  onChange,
  onBlur,
  isInvalid,
  placeholder,
  as,
  rows
}) => {
  const [maxChars, setMaxChars] = useState(-1);

  useEffect(() => {
    if (schema && fieldName) {
      var fieldNameSchema = schema.fields[fieldName];
      if (fieldNameSchema) {
        if (fieldNameSchema.exclusiveTests.max) {
          var fn = fieldNameSchema.tests.find(f => f.OPTIONS.name === "max");
          if (fn) {
            var maxLen = fn.OPTIONS.params.max;
            setMaxChars(maxLen);
          }
        }
      }
    }
  }, [schema, fieldName]);

  return (
    <>
      {title && (
        <Form.Label bsPrefix={required ? "form-label required" : "form-label"}>
          {title} {maxChars > -1 && `(${value ? value.length : 0}/${maxChars})`}
        </Form.Label>
      )}
      <FormControl
        as={as ? as : "input"}
        rows={rows}
        name={fieldName}
        value={value}
        onChange={onChange}
        isInvalid={isInvalid}
        onBlur={onBlur}
        placeholder={placeholder}
        maxLength={maxChars}
      />
      {text && <Form.Text>{text}</Form.Text>}
      <div className={isInvalid ? "is-invalid" : ""} />
    </>
  );
};
export default MaxCharacterField;
